import React from 'react';
import ChatBot from './containers/ChatBot/Chatbot';

const ChatBotTest = () => {
  return (
    <div style={{ padding: '20px', height: '100vh', background: '#f0f0f0' }}>
      <h1>ChatBot Test Page</h1>
      <p>The chatbot should appear as a floating button in the bottom-right corner.</p>
      <p>Click the button to test if it opens.</p>
      
      <ChatBot storeId="test-store-123" />
    </div>
  );
};

export default ChatBotTest; 